import FavoriteIcon from "@mui/icons-material/Favorite";
import Link from "@mui/material/Link";

import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import ROUTE_URLS from "@/constants/route-urls";
import useLanguage from "@/contexts/language-context";
import { SidebarMessages } from "@/messages/layout/sidebar";
import typography from "@/themes/base/typography";

interface FooterProps {
  messages: SidebarMessages;
  compact?: boolean;
}

function Footer({ messages, compact = false }: FooterProps) {
  const { made_with_love, terms, privacy, talk2buy, by } = messages;
  const { size } = typography;
  const { lang } = useLanguage();
  const termsUrl = ROUTE_URLS.terms(lang);
  const privacyUrl = ROUTE_URLS.privacy(lang);

  const company = {
    href: "https://talk2buy.com.br/#hero",
    name: talk2buy,
  };

  const links = [
    {
      href: termsUrl,
      name: terms,
    },
    {
      href: privacyUrl,
      name: privacy,
    },
  ];

  const renderLinks = () =>
    links.map((link) => (
      <MDBox key={link.name} component="li" px={compact ? 1 : 2} lineHeight={1}>
        <Link href={link.href} target="_blank">
          <MDTypography variant="button" fontWeight="regular" color="text" sx={compact ? { fontSize: '0.7rem' } : undefined}>
            {link.name}
          </MDTypography>
        </Link>
      </MDBox>
    ));

  return (
    <MDBox
      width="100%"
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
      px={compact ? 0.5 : 1.5}
    >
      <MDBox
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexWrap="wrap"
        color="text"
        fontSize={compact ? size.xs : size.sm}
        px={compact ? 0.5 : 1.5}
      >
        <MDTypography variant="button" sx={compact ? { fontSize: '0.7rem' } : undefined}>
          &copy; {new Date().getFullYear()}, {made_with_love}
        </MDTypography>
        <MDBox fontSize={compact ? size.sm : size.md} color="text" mb={-0.5} mx={0.25}>
          <FavoriteIcon color="inherit" fontSize="inherit" />
        </MDBox>
        <MDTypography variant="button" sx={compact ? { fontSize: '0.7rem' } : undefined}>{by}</MDTypography>
        <Link href={company.href} target="_blank">
          <MDTypography variant="button" fontWeight="medium" sx={compact ? { fontSize: '0.7rem' } : undefined}>
            &nbsp;{company.name}&nbsp;
          </MDTypography>
        </Link>
      </MDBox>
      <MDBox
        component="ul"
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "center",
          listStyle: "none",
          mt: 0,
          mb: 0,
          p: 0,
        }}
      >
        {renderLinks()}
      </MDBox>
    </MDBox>
  );
}

export default Footer;
